/*
 * Paquete de exportación del servidor MU VANGUARD (08/10/2026): 00_control.csv + 47 archivos.
 * Es la ÚNICA fuente de datos de la guía. Las copias subidas antes no se cargan.
 * Confirmado por configuración ≠ comprobado dentro del juego.
 */

export const EXPORT_DATE_ISO = '2026-10-08'
export const EXPORT_DATE_LABEL = '8 de octubre de 2026'

const CDN = 'https://cdn.magicpatterns.com/uploads/'

export const controlFile = { filename: '00_control.csv', url: `${CDN}4C2WqB1crmuT4wMj6JkbQz/00_control.csv` }

/** filename → URL de cada archivo del paquete (01–47). */
export const packageFiles: { filename: string; url: string }[] = [
  ['01_items.csv', 'm8vshJBSGjtbWDPFhQMu4f'],
  ['02_item_variants.csv', 'jVSXZ7KuaaYaBpecvbtCZW'],
  ['03_categories.csv', 'c2XnUtqsnZQ1rmXiZhWMoj'],
  ['04_classes.csv', 'bvimg8NyMm1ZyzmzuRayGp'],
  ['05_item_classes.csv', '3MiDuNknbE8udTDJVaFk6j'],
  ['06_monsters.csv', 'x9L68HyxjCyyurWkUnEufH'],
  ['07_maps.csv', 'eE9Bk5u3Vb3yXbdz8JTZtA'],
  ['08_spawns.csv', '17rvFQPFyuhfaA5Vasyqmn'],
  ['09_monster_locations.csv', '8aRRDPBU7D6J8eMfPRTT5w'],
  ['10_drop_routes.csv', 'tJyJYNVu9crerzRgMPtwmw'],
  ['11_route_targets.csv', 'brTz3SDUxBmjfANXKhLjVG'],
  ['12_item_drop_rules.csv', '3LxDRwqn9iLuXdkY78v84Z'],
  ['13_item_drop_rule_targets.csv', 'k2HaPeh4B3mLbxJG1qCxVf'],
  ['14_route_events.csv', 'jRhEvrPC88139CBxuW5BUF'],
  ['15_route_ingredients.csv', '2pUzxf2ZKDtbpSgDg2DirZ'],
  ['16_bags.csv', 'xniwy5oJbcJnqLkQwfaAeD'],
  ['17_bag_triggers.csv', 'f9NTEyChiVoNpnu5iyP7Gb'],
  ['18_bag_groups.csv', 'isMJUxb9xYG5uoddST4Lnd'],
  ['19_bag_sections.csv', 'mbJNRfM5SfnPgq1uiVWwVD'],
  ['20_bag_reward_pools.csv', '5UwNst1zQ9wAzx6ZxiwEGo'],
  ['21_bag_rewards.csv', 'gnUP4NTDzaiinhZq2WX4BH'],
  ['22_bag_reward_variants.csv', 'mxmsMAs461NKeNzca7v8VV'],
  ['23_bag_variant_profiles.csv', 'h2jhk1XQPpxAoYRLgVb71Y'],
  ['24_bag_section_classes.csv', 'gUk8jxH1GijAp5yXjC133b'],
  ['25_option_profiles.csv', 'uBwReGTQuTJENkHCuzMhSj'],
  ['26_raw_bag_rows.csv', 'pBS1X1CofopLNbRmsiXLPY'],
  ['27_events.csv', 'doRfZC1BWK5Vosz9AySCKE'],
  ['28_event_schedules.csv', '5oKwetxgbUFmVKG1q416Sh'],
  ['29_event_groups.csv', 'aMB2QSuXfgYDSc9XfFnu8B'],
  ['30_event_map_choices.csv', 'kKJExikPdCELqnnnPsrHSk'],
  ['31_event_monsters.csv', 'gX2cmYc2E7fPCNyQBptjpc'],
  ['32_event_spawn_rules.csv', 'wYx5QgPkBjb42xYsga9t2a'],
  ['33_event_rooms.csv', 'v4DQ7eDRbQfubQ6Xs9S5zY'],
  ['34_event_bags.csv', 'ng79Jz4rPdNC3r8MNQA6yo'],
  ['35_event_direct_items.csv', '9cKCWJC912LShUi4dABGzN'],
  ['36_quests.csv', 'tVkVUJipHxUGu5gVJeLpMx'],
  ['37_quest_rules.csv', 'oAdNdx2THWHqP2v6ueMRGM'],
  ['38_quest_rule_classes.csv', 'oZkY3jCg3WwXR7vUz2FUYB'],
  ['39_quest_objectives.csv', 'u1iwYWx4QPDAjkwh1L94Vb'],
  ['40_quest_objective_classes.csv', 'cvpkDErgBU5GY2soMkTrJi'],
  ['41_quest_drop_rules.csv', '9e6QaRES89mDVyhfYGACCU'],
  ['42_quest_drop_rule_targets.csv', 'gLLFzAa3Fm2PFe7y6vUo1i'],
  ['43_server_rates.csv', 'cEMhBU5zx2mnDZr9riMBWH'],
  ['44_bonus_definitions.csv', '4ptKtvUdJAYfzdkbQoFjqb'],
  ['45_bonus_schedules.csv', 'dRYDnMH45GDmcZGVoLbznT'],
  ['46_bonus_rules.csv', 'wLWX8yU3bcYeDpn5WNiBTf'],
  ['47_map_images.csv', 'vnKZ6XjwtZbxGqAKY1y3hV'],
].map(([filename, key]) => ({ filename, url: `${CDN}${key}/${filename}` }))

export const packageUrl = (filename: string) => packageFiles.find((f) => f.filename === filename)?.url ?? ''
